import { FC } from 'react';
import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { SatisfactionRateIcon } from './utils/SatisfactionRateIcon';

type Props = Readonly<{
	satisfaction: number | null;
	direction?: 'row' | 'column';
}>;

export const JourneySatisfaction: FC<Props> = ({ satisfaction, direction = 'row' }) => {
	if (satisfaction == null) {
		return null;
	}

	return (
		<Stack direction={direction} alignItems={'center'} justifyContent={'center'} gap={0.5}>
			<SatisfactionRateIcon rate={satisfaction} />
			<Typography variant={'body1'} fontSize={12}>
				{/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
				{satisfaction}%
			</Typography>
		</Stack>
	);
};
